import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import LinkCallback from "@/pages/LinkCallback";
import NextGenStubLogin from "@/pages/NextGenStubLogin";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <a href="#main" className="skip-link">Skip to content</a>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/link/callback" element={<LinkCallback />} />
            <Route path="/link/nextgen-stub" element={<NextGenStubLogin />} />
            <Route path="/privacy" element={<Legal doc="privacy" />} />
            <Route path="/terms" element={<Legal doc="terms" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </div>
    </AuthProvider>
  );
}

export default App;
